"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

require("./adminManagement.scss");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _Username = _interopRequireDefault(require("../../../components/username/Username"));

var _EditableTable = _interopRequireDefault(require("../../../components/table/EditableTable"));

var _api = _interopRequireDefault(require("../../../redux/api"));

var _user = require("../../../redux/user/user.types");

var _api2 = require("../../../redux/api/api.types");

var _typesafeActions = require("typesafe-actions");

var _Util = require("../../../components/util/Util");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _AntdIcon = _interopRequireDefault(require("../../../components/antdIcon/AntdIcon"));

var _withStyles = _interopRequireDefault(require("react-international-telephone-input/lib/withStyles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const flagsImagePath = require("../../../assets/images/flags.png");

const {
  Option
} = _select.default;
const {
  confirm
} = _modal.default;

class AdminManagementLandingPage extends _react.Component {
  constructor(props) {
    super(props);

    this.onPasswordResetClick = () => {
      this.setState({
        isPasswordResetVisible: true
      });
    };

    this.onPasswordResetClose = () => {
      this.setState({
        isPasswordResetVisible: false
      });
    };

    this.onResetAdminPassword = ({
      password,
      updatePseudoParticipants
    }) => {
      const {
        selectedRowKeys
      } = this.state;
      const {
        updatePassword
      } = this.props;
      confirm({
        title: 'Are you sure you want to change this password?',
        onOk: () => {
          updatePassword({
            password,
            userIds: selectedRowKeys,
            updatePseudoParticipants
          });
          this.onPasswordResetClose();
        },

        onCancel() {}

      });
    };

    this.rowClassName = (record, index) => index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';

    this.renderRoles = (value, record, index) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: `${record.key}-roles`
      }, record.roles.map(role => role.role.role).join(', '));
    };

    this.renderEditRoles = (record, ref, rules, save) => {
      const {
        roles
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_form.default.Item, {
        key: "roleIds",
        name: "roleIds",
        rules: rules,
        style: {
          margin: 0
        },
        initialValue: record.roles.map(role => role.role.id)
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        ref: ref,
        mode: "multiple",
        allowClear: true,
        showSearch: false,
        dropdownMatchSelectWidth: false,
        onChange: values => {
          this.onRolesChange(values, record.id);

          if (save) {
            save();
          }
        },
        onBlur: () => {
          if (save) {
            save();
          }
        }
      }, roles === null || roles === void 0 ? void 0 : roles.map(role => /*#__PURE__*/_react.default.createElement(Option, {
        key: `role-${role.id}`,
        value: role.id
      }, role.role))));
    };

    this.renderEditMobile = (record, ref, rules, save) => {
      return /*#__PURE__*/_react.default.createElement(_form.default.Item, {
        key: "mobile",
        name: "mobile",
        rules: rules,
        style: {
          margin: 0
        },
        initialValue: record.mobile
      }, /*#__PURE__*/_react.default.createElement(_withStyles.default, {
        inputProps: {
          style: {
            minHeight: '32px'
          }
        },
        className: "editable-cell-input",
        onBlur: save,
        onChange: save,
        flagsImagePath: flagsImagePath
      }));
    };

    this.renderParticipants = (value, record, index) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: `${record.key}-participants`
      }, record.pseudoParticipantIds.map(id => /*#__PURE__*/_react.default.createElement(_Username.default, {
        key: `${record.key}-${id}-username`,
        participantId: id
      })).reduce((prev, curr, index) => index > 0 ? [...prev, /*#__PURE__*/_react.default.createElement("span", {
        key: `${record.key}-${index}-comma`
      }, ", "), curr] : [curr], new Array()));
    };

    this.handleSave = user => {
      // dispatch update admin user
      const {
        roleUpdate
      } = this.state;
      const {
        updateAdminUser
      } = this.props;

      if (roleUpdate && roleUpdate.userId === user.id) {
        updateAdminUser({
          user,
          roleIds: roleUpdate.roleIds
        });
      } else {
        updateAdminUser({
          user
        });
      }

      if (roleUpdate) {
        this.setState({
          roleUpdate: undefined
        });
      }
    };

    this.onRolesChange = (roleIds, userId) => {
      this.setState({
        roleUpdate: {
          userId,
          roleIds
        }
      });
    };

    this.onSelectedRowsChange = selectedRowKeys => {
      this.setState({
        selectedRowKeys
      });
    };

    this.onDeleteSelectedAdmin = () => {
      const {
        selectedRowKeys
      } = this.state;
      const {
        deleteAdminUser
      } = this.props;
      confirm({
        title: 'Are you sure you want to delete these admin?',
        content: 'Once the delete date is set, they will no longer have app access and will only be able to login to the admin portal up until the delete date passes.',
        okText: 'Delete',
        okType: 'danger',
        onOk: () => {
          deleteAdminUser({
            userIds: selectedRowKeys
          }); // Clear selectedRowKeys after performing an action

          this.setState({
            selectedRowKeys: []
          });
        },

        onCancel() {}

      });
    };

    this.state = {
      selectedRowKeys: [],
      isPasswordResetVisible: false,
      columns: [{
        key: 'id-col',
        title: 'ID',
        dataIndex: 'id'
      }, {
        key: 'username-col',
        title: 'Username',
        dataIndex: 'username'
      }, {
        key: 'firstName-col',
        title: 'First Name',
        dataIndex: 'firstName'
      }, {
        key: 'lastName-col',
        title: 'Last Name',
        dataIndex: 'lastName'
      }, {
        key: 'roles-col',
        title: 'Roles',
        dataIndex: 'id',
        render: this.renderRoles
      }, {
        key: 'participants-col',
        title: 'Participants',
        dataIndex: 'id',
        render: this.renderParticipants
      }, {
        key: 'email-col',
        title: 'Email',
        dataIndex: 'email'
      }, {
        key: 'mobile-col',
        title: 'Mobile',
        dataIndex: 'mobile'
      }, {
        key: 'deleteDate-col',
        title: 'Delete Date',
        dataIndex: 'deleteDate',
        render: date => (0, _Util.renderDateWithTime)(date)
      }]
    };
    props.getAdmin();
    props.getAdminRoles();
  }

  componentDidMount() {
    // If current user has the Study Manager role, update columns to be editable
    if (this.props.hasStudyManagerRole) {
      this.setState({
        columns: [{
          key: 'id-col',
          title: 'ID',
          dataIndex: 'id'
        }, {
          key: 'username-col',
          title: 'Username',
          dataIndex: 'username',
          editable: true,
          required: true,
          validator: async (rule, value) => {
            const {
              studyId
            } = this.props;

            if (!value || value.length === 0) {
              return Promise.reject('Username is a required field.');
            }

            const isUsernameAvailable = await (0, _api.default)({
              method: 'get',
              url: `/a/usmg/availability/username/${value}?isAdminUser=true&studyId=${studyId}`
            });

            if (!isUsernameAvailable.data) {
              return Promise.reject('This username is already in-use.');
            }

            return Promise.resolve();
          }
        }, {
          key: 'firstName-col',
          title: 'First Name',
          dataIndex: 'firstName',
          editable: true,
          required: true
        }, {
          key: 'lastName-col',
          title: 'Last Name',
          dataIndex: 'lastName',
          editable: true
        }, {
          key: 'roles-col',
          title: 'Roles',
          dataIndex: 'roles',
          render: this.renderRoles,
          editable: true,
          editRender: this.renderEditRoles
        }, {
          key: 'participants-col',
          title: 'Participants',
          dataIndex: 'id',
          render: this.renderParticipants
        }, {
          key: 'email-col',
          title: 'Email',
          dataIndex: 'email',
          editable: true,
          required: true
        }, {
          key: 'mobile-col',
          title: 'Mobile',
          dataIndex: 'mobile',
          editable: true,
          editRender: this.renderEditMobile
        }, {
          key: 'deleteDate-col',
          title: 'Delete Date',
          dataIndex: 'deleteDate',
          render: date => (0, _Util.renderDateWithTime)(date)
        }]
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      clearLoadStatus,
      updateAdminPasswordStatus,
      updateAdminUserStatus,
      deleteAdminUserStatus
    } = this.props;

    if (!prevProps.updateAdminPasswordStatus.isError && updateAdminPasswordStatus.isError) {
      _message2.default.error(`Error while updating admin password.`);

      clearLoadStatus((0, _typesafeActions.getType)(_user.updateAdminPasswordAsync.failure));
    } else if (!prevProps.updateAdminPasswordStatus.isSuccess && updateAdminPasswordStatus.isSuccess) {
      _message2.default.success('Admin password successfully updated.');

      clearLoadStatus((0, _typesafeActions.getType)(_user.updateAdminPasswordAsync.success));
    }

    if (!prevProps.updateAdminUserStatus.isError && updateAdminUserStatus.isError) {
      _message2.default.error(`Error while updating admin user.`);

      clearLoadStatus((0, _typesafeActions.getType)(_user.updateAdminUserAsync.failure));
    } else if (!prevProps.updateAdminUserStatus.isSuccess && updateAdminUserStatus.isSuccess) {
      _message2.default.success('Admin user successfully updated.');

      clearLoadStatus((0, _typesafeActions.getType)(_user.updateAdminUserAsync.success));
    }

    if (!prevProps.deleteAdminUserStatus.isError && deleteAdminUserStatus.isError) {
      _message2.default.error(`Error while deleting admin user(s).`);

      clearLoadStatus((0, _typesafeActions.getType)(_user.deleteAdminUserAsync.failure));
    } else if (!prevProps.deleteAdminUserStatus.isSuccess && deleteAdminUserStatus.isSuccess) {
      _message2.default.success('Admin user(s) successfully deleted.');

      clearLoadStatus((0, _typesafeActions.getType)(_user.deleteAdminUserAsync.success));
    }
  }

  componentWillUnmount() {
    if (this.state.isPasswordResetVisible) {
      this.setState({
        isPasswordResetVisible: false
      });
    }

    if (this.state.roleUpdate) {
      this.setState({
        roleUpdate: undefined
      });
    }
  }

  render() {
    const {
      admin,
      hasStudyManagerRole
    } = this.props;
    const {
      columns,
      selectedRowKeys,
      isPasswordResetVisible
    } = this.state;
    let rowSelection;

    if (hasStudyManagerRole) {
      rowSelection = {
        selectedRowKeys,
        onChange: this.onSelectedRowsChange
      };
    }

    return /*#__PURE__*/_react.default.createElement(_card.default, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "admin-management-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Admin"))
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
      className: "table-selection-title"
    }, "Actions:"), /*#__PURE__*/_react.default.createElement("div", {
      className: "table-selection-actions"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      title: "Delete admin users",
      disabled: selectedRowKeys.length === 0,
      onClick: this.onDeleteSelectedAdmin,
      className: "table-selection-action"
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proRegularSvgIcons.faTrashAlt,
      classes: "action-icon"
    }), /*#__PURE__*/_react.default.createElement("strong", null, "Delete")), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      title: "Change admin password(s)",
      disabled: selectedRowKeys.length === 0,
      onClick: this.onPasswordResetClick,
      className: "table-selection-action"
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proRegularSvgIcons.faKey,
      classes: "action-icon"
    }), /*#__PURE__*/_react.default.createElement("strong", null, "Change password")))), /*#__PURE__*/_react.default.createElement(_EditableTable.default, {
      columns: columns,
      dataSource: admin === null || admin === void 0 ? void 0 : admin.map(a => ({ ...a,
        key: a.id
      })),
      rowKey: "id",
      rowClassName: this.rowClassName,
      handleSave: this.handleSave,
      rowSelection: rowSelection,
      disabled: !hasStudyManagerRole
    }), /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Reset Password",
      className: "admin-action",
      visible: isPasswordResetVisible,
      onCancel: this.onPasswordResetClose,
      footer: null,
      destroyOnClose: true
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      name: "basic",
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 16
      },
      initialValues: {
        updatePseudoParticipants: false
      },
      onFinish: values => {
        this.onResetAdminPassword(values);
      },
      autoComplete: "off"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Password",
      name: "password",
      rules: [{
        required: true,
        message: 'Please input password'
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default.Password, null)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Confirm Password",
      name: "confirmPassword",
      rules: [{
        required: true,
        message: 'Please confirm the entered password'
      }, ({
        getFieldValue
      }) => ({
        validator(_, value) {
          if (!value || getFieldValue('password') === value) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('The two passwords that you entered do not match!'));
        }

      })]
    }, /*#__PURE__*/_react.default.createElement(_input.default.Password, null)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "updatePseudoParticipants",
      valuePropName: "checked",
      wrapperCol: {
        offset: 8,
        span: 16
      }
    }, /*#__PURE__*/_react.default.createElement(_checkbox.default, null, "Update associated pseudo participants too?")), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      wrapperCol: {
        offset: 8,
        span: 16
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      htmlType: "submit",
      style: {
        marginRight: '8px'
      }
    }, "Submit"), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: "cancel",
      onClick: this.onPasswordResetClose
    }, "Cancel")))));
  }

}

const mapStateToProps = state => {
  return {
    admin: selectors.getAdmin(state),
    roles: selectors.getAdminRoles(state),
    user: selectors.selectUser(state),
    studyId: selectors.getRequestedStudyId(state),
    updateAdminPasswordStatus: selectors.updateAdminPasswordStatus(state),
    updateAdminUserStatus: selectors.updateAdminUserStatus(state),
    deleteAdminUserStatus: selectors.deleteAdminUserStatus(state),
    hasStudyManagerRole: selectors.hasStudyManagerRole(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updatePassword: args => dispatch(_user.updateAdminPasswordAsync.request(args)),
    updateAdminUser: args => dispatch(_user.updateAdminUserAsync.request(args)),
    deleteAdminUser: args => dispatch(_user.deleteAdminUserAsync.request(args)),
    getAdmin: () => dispatch(_user.getAdminAsync.request()),
    getAdminRoles: () => dispatch(_user.getAdminRolesAsync.request()),
    clearLoadStatus: type => dispatch((0, _api2.clearStatus)(type))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdminManagementLandingPage);

exports.default = _default;